var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-radio",class:{active: _vm.checked}},[_c('div',{staticClass:"items"},[_vm._t("default"),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }